/**
 * Pluggable channel loaders for outbound messaging UI.
 */

import { getPartners } from "../../features/partners/services/partnerService.js";
import { normalizeChannel } from "./outboundMessaging.js";

/**
 * Load WhatsApp-ready partner channels for lead sharing.
 * @returns {Promise<Array>}
 */
export async function loadPartnerChannels() {
  const result = await getPartners({
    isActive: true,
    phoneIsWhatsApp: true,
  });

  if (!result.success) {
    throw new Error(result.error || "Failed to load providers");
  }

  return (result.data || [])
    .map((partner) =>
      normalizeChannel({
        id: partner.id,
        label: partner.name,
        phone: partner.phone,
        type: "whatsapp",
        subtitle: `${partner.contactPerson || "Contact"} · ${partner.phone}`,
      })
    )
    .filter(Boolean);
}

/**
 * Build ops/business line channels from public system settings.
 * @param {Object} settings
 * @returns {Array}
 */
export function loadOpsChannelsFromSettings(settings = {}) {
  const channels = [];
  const configured = settings["messaging.channels"];

  if (Array.isArray(configured)) {
    for (const item of configured) {
      const normalized = normalizeChannel(item);
      if (normalized) channels.push(normalized);
    }
  }

  if (channels.length === 0) {
    const fallbackPhone =
      settings["contact.whatsappPhone"] || settings["contact.phone"];
    if (fallbackPhone) {
      channels.push(
        normalizeChannel({
          id: "main",
          label: "Bubakii Main",
          phone: fallbackPhone,
          type: "whatsapp",
        })
      );
    }
  }

  return channels.filter(Boolean);
}
